import { CircularProgress } from "@mui/material";
import CustomSnackbar from "components/snackbar";
import { getInBrainOfferwallUrl } from "data/slices/inbrain/api";
import keys from "locale/keys";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SNACKBAR_TYPE } from "utils/constants";

import {
  CenteredState,
  MoreSurveysWrapper,
  PortalFrame,
} from "./styled.components";

interface MoreSurveysContainerProps {
  // When rendered inside the surveys hub, fill the hub's panel instead of
  // sizing itself to the viewport.
  embedded?: boolean;
}

const MoreSurveysContainer = (props: MoreSurveysContainerProps) => {
  const { embedded } = props;
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [offerwallUrl, setOfferwallUrl] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  useEffect(() => {
    let isMounted = true;

    const fetchOfferwallUrl = async () => {
      setIsLoading(true);
      const data = await getInBrainOfferwallUrl();
      if (!isMounted) return;

      const url = data?.response?.url;
      if (url) {
        setOfferwallUrl(url);
      } else {
        setSnackbarMsg(data?.message || t(keys.more_surveys_load_error));
        setShowSnackbar(true);
      }
      setIsLoading(false);
    };

    fetchOfferwallUrl();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MoreSurveysWrapper embedded={embedded}>
      {isLoading ? (
        <CenteredState>
          <CircularProgress />
        </CenteredState>
      ) : (
        offerwallUrl && (
          <PortalFrame
            src={offerwallUrl}
            title={t(keys.more_surveys)}
            allow="clipboard-write; fullscreen"
          />
        )
      )}
      <CustomSnackbar
        msg={snackbarMsg}
        type={SNACKBAR_TYPE.ERROR}
        show={showSnackbar}
        dismiss={() => setShowSnackbar(false)}
      />
    </MoreSurveysWrapper>
  );
};

export default MoreSurveysContainer;
